/** The user preference that holds the persisted default tenant. */
export const DEFAULT_TENANT_PREF_KEY = 'default_tenant_id';

/**
 * Which organization the device approve page preselects (#9950): the client's
 * required tenant when the approver holds it, else the approver's persisted
 * default when it is still a membership, else the first membership. It never
 * forces a chooser: any approver with a membership gets a preselection.
 *
 * This is the Lean model's `specPreselect` (formal/auth/Auth/Device/Model.lean).
 * Bridge.lean proves it equals formal/onboarding's `expectedTenant` (Cole's
 * default-tenant rule) and R5 for the training client.
 */
export function preselectTenant(orgIds: string[], defaultTenantId?: string | null, requiredTenantId?: string | null): string {
  if (requiredTenantId && orgIds.includes(requiredTenantId)) return requiredTenantId;
  if (defaultTenantId && orgIds.includes(defaultTenantId)) return defaultTenantId;
  return orgIds[0] ?? '';
}